import { fromJS } from 'immutable';

export const PAID_COHORT_DEFAULT_CURRENCY = 'AUD';

export const PAID_COHORT_IAP_CURRENCY = 'AUD';

export const iosCourseTiers = fromJS({
  courseTier19: 19.99,
  courseTier39: 39.99,
  courseTier59: 59.99,
  courseTier79: 79.99,
  courseTier99: 99.99,
  courseTier149: 149.99,
  courseTier199: 199.99,
  courseTier249: 249.99,
  courseTier299: 299.99,
  courseTier349: 349.99,
  courseTier399: 399.99,
  courseTier449: 449.99,
  courseTier899: 899.99,
});
